// Buyer-facing platform fee, MUST stay identical to the backend
// (src/lib/handlers/tickets/order-checkout.ts computeBuyerPlatformFee), so the
// order summary shows exactly what Stripe charges. Our margin (feeBps of the
// subtotal) grossed up to also cover Stripe's processing, since we don't pass
// Stripe to the organiser: the organiser keeps a clean face value, we keep a
// clean margin, the buyer pays one "Platform fee" line.
const STRIPE_PCT_BPS = 150;
const STRIPE_FIXED_CENTS = 20;

export function computeBuyerPlatformFee(subtotalCents: number, feeBps: number): number {
  if (subtotalCents <= 0 || feeBps <= 0) return 0;
  const margin = Math.round((subtotalCents * feeBps) / 10000);
  const stripePct = STRIPE_PCT_BPS / 10000;
  const grossed = (margin + subtotalCents * stripePct + STRIPE_FIXED_CENTS) / (1 - stripePct);
  return Math.ceil(grossed);
}
